export default {
  copy: 'Copy',
} as const;
